import _ from 'lodash';
import moment from 'moment-timezone';

import './style.styl';

angular.module(__filename, []).directive(
  'dayOverrides',
  ngInject(() => ({
    restrict: 'E',
    scope: {
      overrides: '=ngModel',
      expanded: '=',
      foodhub: '=',
      dayLabel: '@',
    },
    template: require('./template'),
    controllerAs: 'ctrl',
    bindToController: true,
    require: 'ngModel',
    controller: ngInject(function() {
      this.datePickerOpen = false;
      this.datePickerMinDate = moment()
        .startOf('day')
        .add(1, 'day')
        .toDate();

      this.dayToExclude = null;

      this.excludeDropoffDay = () => {
        if (!this.dateIsInFuture(this.dayToExclude)) {
          return;
        }
        const dropoffDay = moment(this.dayToExclude).format('YYYY-MM-DD');
        if (this.overrides.find((override) => override.dropoffDay === dropoffDay)) {
          return;
        }
        this.overrides.push({
          dropoffDay,
          schedule: {enabled: false},
        });
        this.dayToExclude = null;
      };

      this.includeDropoffDay = (dropoffDay) =>
        // eslint-disable-next-line goodeggs/lodash-prefer-immutable-method
        _.remove(this.overrides, (override) => override.dropoffDay === dropoffDay);

      this.openDatePicker = function() {
        this.datePickerOpen = true;
      };

      this.formatDate = (date) => moment(date).format('dddd, LL');

      this.dateIsInFuture = (date) => moment(date).isAfter(moment());

      this.recentFilter = (date) => moment(date).isAfter(moment().subtract(2, 'weeks'));

      return this;
    }),
  })),
);

export default __filename;
